import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  public hubConnection: signalR.HubConnection;

  constructor() {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withAutomaticReconnect()
      .withUrl(`${environment.waiApi}/chathub`, { withCredentials: false })
      .build();
    // this.hubConnection.on('ReceiveMessage', (direction, from, to, idMessage) => {
    //   console.log(`User: ${user}, Message: ${message}`);
    // });
    this.hubConnection
    .start()
    .catch((err) => 
      console.error(err));
  }
}
